<label
  *ngIf="fareFamily$ | async as fareFamily"
  class="grey-25-bg ps-large-r border-top fill flex flex--space-between flex--wrap flex--middle cabin-class-option rounded-bottom-large multicity-fare-family"
  [style.--brand-color]="fareFamily?.brandColor"
  [class.selected]="isChecked$ | async"
  role="option"
  [attr.aria-selected]="isChecked$ | async"
  [attr.aria-label]="
    'multiCity.flightSelection.ariaFareFamily'
      | finLocalization
        : {
            fareFamily: fareFamily.brandName,
            basePrice:
              {
                amount: basePrice$ | async,
                currencyCode: currencyCode,
              } | finPrice,
            priceDifference:
              (+(priceDifference$ | finMap: 'amount' | async) < 0 ? '-' : '+') +
              (priceDifference$ | async | finPrice: { absoluteValue: true }),
          }
  "
  [attr.data-testid]="'fare-family-options-label-' + fareFamily.fareFamilyCode"
>
  <input
    [attr.data-testid]="'fare-family-checkbox-' + fareFamily.fareFamilyCode"
    (change)="checkboxChange()"
    type="checkbox"
    class="is-vishidden"
    [checked]="isChecked$ | async"
    [disabled]="fareFamily.disabled"
  />
  <span class="flex fill">
    <span class="flex--nogrow flex--middle flex highlight rounded-left-large">
      <span class="ps-xsmall">
        <fcom-icon
          class="icon-medium circle nordic-blue-900-border white-bg"
          [name]="
            (isChecked$ | async) ? SvgLibraryIcon.CHECKMARK_BUTTON_SELECTED : SvgLibraryIcon.CHECKMARK_BUTTON_UNSELECTED
          "
        ></fcom-icon>
      </span>
    </span>
    <span class="flex-1 flex flex--wrap ps-xsmall-y spacer-tablet-down">
      <span class="flex-1 flex flex--middle pr-small-r font-body-1 brand-name">
        {{ fareFamily.brandName }}
      </span>

      <span class="flex flex--middle price-container">
        <span class="font-body-1 bold-type nordic-blue-900-text price">
          <ng-container *ngIf="priceDifference$ | async">
            {{
              (+(priceDifference$ | finMap: 'amount' | async) < 0 ? '-' : '+') +
                (priceDifference$ | async | finPrice: { absoluteValue: true })
            }}
          </ng-container>
          <ng-container *ngIf="(priceDifference$ | async) === null">
            {{ defaultPrice$ | async | finPrice }}
          </ng-container>
        </span>
      </span>
    </span>
  </span>
</label>
